import './DeleteFile.css'
import { RiDeleteBinLine } from 'react-icons/ri';
import { Amplify, Storage } from "aws-amplify";
import awsconfig from "../aws-exports";
import ConfirmDeletePopUp from './ConfirmDeletePopUp';
import { useState } from 'react';
import { Tooltip } from '@mui/material';
Amplify.configure(awsconfig);

function DeleteFile(props) {

    const { /*bucketname,*/ file, onDelete, currentPath } = props

    const [isOpen, setIsOpen] = useState(false)

    let removeFile = async () => {
        if (file.key !== undefined) {
            await Storage.remove(file.key, {
                // bucket: bucketname,
                level: 'private',
            });
            onDelete(file.key);
        } else {
            // Add a trailing slash if it's not present (to treat it as a folder)
            let folderPrefix = file.endsWith('/') ? file : file + '/';

            // Recursively fetch and delete all files under this folder
            let deleteRecursive = async (prefix) => {
                let response = await Storage.list(prefix, {
                    // bucket: bucketname,
                    level: 'private',
                });

                // If there are files in this folder, remove them
                for (let f of response.results) {
                    await Storage.remove(f.key, {
                        // bucket: bucketname,
                        level: 'private',
                    });
                    onDelete(f.key);
                }

                // If there were files and folders, the list might be truncated. Check again.
                if (response.results.length > 0) {
                    await deleteRecursive(prefix);
                }
            }

            // Start the recursive delete
            await deleteRecursive(folderPrefix);

            // Note: In S3, folders (empty prefixes with '/') don't exist like traditional filesystems.
            // The folders appear because of the files' naming conventions. So, you don't need to 
            // delete the folder separately after deleting its content.
        }
    }

    function onDeleteClickHandler() {
        isOpen === true ? setIsOpen(false) : setIsOpen(true)
    }

    return <>
        <Tooltip title="Delete" placement="top">
            <button onClick={() => { onDeleteClickHandler() }} className='delete-button' id='delete' ><RiDeleteBinLine className='delete-button__icon' /></button>
        </Tooltip>
        <ConfirmDeletePopUp file={file} isOpen={isOpen} setIsOpen={setIsOpen} removeFile={removeFile} currentPath={currentPath.toString()}></ConfirmDeletePopUp>
    </>
}

export default DeleteFile